import { CounterpartyInvite } from './CounterpartyInvite';

export default CounterpartyInvite;
